import { createBrowserRouter, Navigate } from 'react-router-dom';
import Registration from './pages/Registration';
import RegistrationResult from './pages/RegistrationResult';
import AIDelivery from './pages/AIDelivery';
import LandingPage from "@/pages/LandingPage.jsx";


const NotFound = () => (
    <div className="not-found container text-center py-5">
        <h1>404 - Page Not Found</h1>
        <p className="mb-4">The page you are looking for does not exist.</p>
        <a href="/" className="button">Go to Home</a>
    </div>
);

const router = createBrowserRouter([
    {
        path: "/",
        element: <LandingPage />,
    },
    {
        path: "/register/:uuid",
        element: <Registration />,
        loader: async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            return { success: true };
        },
    },
    {
        path: "/event/:uuid/registration-result/:status",
        element: <RegistrationResult />,
        loader: async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            return { success: true };
        },
    },
    {
        path: "/matches/:uuid",
        element: <AIDelivery />,
        loader: async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            return { success: true };
        },
    },
    {
        path: "*",
        element: <NotFound />
    }
]);

export default router;